import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import FormatterCommon from '../../../../app/data-formatters/formatter-common';
import DataService from '../../services/data.service';
import DataServiceSecure from '../../services/data-secure.service';
import UtilsService from '../../../../services/utils.service';
import kpiAndTrendOptions from '../../dialogs/panel-options/kpi-n-trend-options/kpi-n-trend-options';
import kpiAndTrendService from '../panel/kpi-n-trend-panel.service';
import '../../../../app/bindings/ko-custombinding-gauge';


    //  Semantic text types
    var BAD = 'BAD';
    var FAIR = 'FAIR';
    var GOOD = 'GOOD';
    var NEUTRAL = 'NEUTRAL';
    var NONE = 'NONE';
    var UNKNOWN = 'UNKNOWN';

    var summaryMetricType = { id: 'summary', name: 'Summary' };

    function KpiPanel(params) {
        var self = this;

        self.panelId = _.get(params, 'panelId');
        self.dateRangeModel = _.get(params, 'dateRange');

        self.panelOptionsUpdatedSignal = _.get(params, 'signals.panelOptionsUpdated');
        self.showLoadingIconSignal = _.get(params, 'signals.showLoadingIcon');
        self.titleChangedSignal = _.get(params, 'signals.titleChanged');
        if (!_.isNil(self.titleChangedSignal)) {
            self.titleChangedSignal.add(function(title) {
                var selectedOptions = ko.unwrap(self.selectedOptions);
                self.selectedOptions(_.assign(selectedOptions, { title: title }));
            });
        }

        self.showOptionsSignal = _.get(params, 'signals.showOptions');
        if (!_.isNil(self.showOptionsSignal)) {
            self.showOptionsSignal.add(self.onShowOptions.bind(self));
        }

        // //  FIXME: what's this signal for? - 'panel' complains when missing..    :O
        // self.resizeSignal = params.signals.resizeSignal;

        kpiAndTrendService.migrate(params);
        self.selectedOptions = ko.observable(params.options);
        self.isPercentage = ko.pureComputed(function () {
            return Boolean(_.get(ko.unwrap(self.selectedOptions), 'isPercentage'));
        });

        self.customSectors = ko.observableArray([]);
        self.forceRedraw = ko.observable(false);
        self.max = ko.observable(100);
        self.min = ko.observable(0);
        self.statusClass = ko.observable();
        self.value = ko.observable();

        self.subscriptions = {};

        self.subscriptions.dateRange = self.dateRangeModel.currentRangeUpdated.add(self.fetchDataset, self);

        self.dispatchShowLoadingIcon(true);
        self.fetchDataset();

        $(window).resize(function () {
            self.forceRedraw(true);
        });
    }

    KpiPanel.prototype = {
        applyStatusClass: function (quality) {
            var self = this;
            var cssClass;
            switch (quality.toUpperCase()) {
                case BAD:
                case FAIR:
                case GOOD:
                case NEUTRAL:
                    cssClass = 'status-' + quality.toLowerCase() + '-quality';
                    break;

                default:
                    cssClass = 'status-unknown-quality';
            }
            self.statusClass(cssClass);
        },

        dispatchShowLoadingIcon: function (show) {
            var self = this;
            UtilsService.dispatchSignal(self.showLoadingIconSignal, show);
        },

        dispose: function () {
            var self = this;
            _.forEach(self.subscriptions, function (subscription) {
                if (typeof subscription.dispose === 'function') {
                    subscription.dispose();
                } else if (typeof subscription.detach === 'function') {
                    subscription.detach();
                }
            });
        },

        fetchDataset: function () {
            var self = this;
            var selectedDateRange = ko.unwrap(self.dateRangeModel.getCurrentRange());
            var selectedOptions = ko.unwrap(self.selectedOptions);

            var params = {
                start: selectedDateRange.startDate,
                end: selectedDateRange.endDate,
                name: selectedOptions.metricId,
                resultType: selectedOptions.analysisId,
                query: kpiAndTrendService.getApiReadyQueryTagFilters(selectedOptions.filters),
                group_by: _.isArray(selectedOptions.groupBy) ? selectedOptions.groupBy.join(',') : selectedOptions.groupBy,
                aggregation: selectedOptions.aggregateFunction,
            };

            DataServiceSecure
                .fetchMetrics(params)
                .then(function (data) {
                    var value = _.toNumber(_.get(data, 'value'));
                    var formattedValue = FormatterCommon.getFormattedNumber(value, true);
                    var isPercentage = _.includes(selectedOptions.metricId, 'percent');

                    if (isPercentage) {
                        formattedValue += '%';
                    }
                    self.value(formattedValue);

                    var qualityCategory = selectedOptions.qualityCategory; // todo this should be looked up in metadata dynamically
                    self.applyStatusClass(qualityCategory);
                    self.finalizeDrawing();
                })
                .catch(function (error) {
                    console.error(error.message);
                    self.finalizeDrawing();
                });
        },

        finalizeDrawing: function () {
            var self = this;
            self.dispatchShowLoadingIcon(false);
            self.forceRedraw(true);
        },

        onOptionsChanged: function (updatedOptions) {
            var self = this;
            var title = updatedOptions.params.title;

            var updatedPanelOptions = _.assign({},
                updatedOptions.panel,
                {
                    id: ko.unwrap(self.panelId),
                    params: {
                        options: updatedOptions.params
                    }
                }
            );

            // if (!_.isNil(self.subscriptions.optionsChanged)) {
            //     self.subscriptions.optionsChanged.dispose();
            // }

            var selectedOptions = ko.unwrap(self.selectedOptions);
            self.selectedOptions(
                _.assign(selectedOptions, updatedOptions.params)
            );

            // self.subscriptions.optionsChanged = self.selectedOptions.subscribe(self.onOptionsChanged, self);


            UtilsService.dispatchSignal(self.titleChangedSignal, title);
            UtilsService.dispatchSignal(self.panelOptionsUpdatedSignal, updatedPanelOptions);

            self.fetchDataset();
        },

        onShowOptions: function () {
            var self = this;
            DataService
                .fetchMetricsMetadata()
                .then(function (metadata) {
                    kpiAndTrendOptions
                        .dialog({
                            metadata: metadata,
                            selections: _.cloneDeep(ko.unwrap(self.selectedOptions))
                        })
                        .then(function (selectedOptions) {
                            if (!_.isNil(selectedOptions)) {
                                self.onOptionsChanged(selectedOptions);
                            }
                        }, function(){})// no error handling needed on close);
                });
        }
    };

    export default KpiPanel;
